import useOfferDetailViewerKey from 'tripPlanner/hooks/useOfferDetailViewerKey'
import { useQuery } from '@tanstack/react-query'
import { getOfferDetail } from 'tripPlanner/api'
import * as OfferDetailKeys from 'tripPlanner/hooks/reactQueryKeys/offerDetail'
import { OFFER_DETAIL_STALE_TIME } from 'tripPlanner/hooks/api/queryConstants'

export interface UseOfferDetailsOptions {
  offerId: string | undefined
  region: string
  offerType?: string
  accommodationPropertyId?: string
  checkIn?: string
  checkOut?: string
  occupancies?: string
  flexibleMonths?: string
  flexibleNights?: string
  orderId?: string
  enabled?: boolean
}

interface UseOfferDetailsQueryOptions extends UseOfferDetailsOptions {
  keepPreviousData?: boolean
}

export function useOfferDetailsQuery({
  offerId,
  region,
  offerType,
  accommodationPropertyId,
  checkIn,
  checkOut,
  occupancies,
  flexibleMonths,
  flexibleNights,
  orderId,
  enabled = true,
  keepPreviousData,
}: UseOfferDetailsQueryOptions) {
  const viewerKey = useOfferDetailViewerKey()
  return useQuery({
    queryKey: OfferDetailKeys.detail(
      offerId ?? '',
      region,
      accommodationPropertyId,
      offerType,
      checkIn,
      checkOut,
      occupancies,
      flexibleMonths,
      flexibleNights,
      orderId,
      viewerKey,
    ),
    queryFn: () =>
      getOfferDetail({ offerId: offerId!, region, offerType, accommodationPropertyId, checkIn, checkOut, occupancies, flexibleMonths, flexibleNights, orderId }),
    enabled: enabled && !!offerId,
    staleTime: OFFER_DETAIL_STALE_TIME,
    keepPreviousData,
  })
}

export default function useOfferDetails(options: UseOfferDetailsOptions) {
  const queryResult = useOfferDetailsQuery(options)

  return {
    offerDetail: queryResult.data,
    isLoading: queryResult.isLoading && queryResult.fetchStatus !== 'idle',
    isError: queryResult.isError,
    refetch: queryResult.refetch,
  }
}
